import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useRef } from "react";
import { addDoc, collection, doc, getDoc, getDocs } from "firebase/firestore";
import { confirmarSistema } from "../Components/PopupSistema/PopupSistema";
import { useHistory, useParams } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import CabecalhoDetalhes from "../Components/CabecalhoDetalhes/CabecalhoDetalhes";
import { db } from "../Config/firebase";
import { aplicarTenantAtual, consultaTenantAtual } from "../Utils/tenant";
import { gerarSequencial } from "../Utils/sequencial";
import { AMBIENTE_PRODUCAO } from "../Config/branding";
import { atualizarDocumentoComMesclagem } from "../Utils/concorrenciaFirestore";
import RelatorioCaracterizacaoGraudoPrint, { ChartGranulometria } from "./relatoriocaracterizacaoGraudoPrint";
import RelatorioCaracterizacaoResumoPrint from "../Relatorios/RelatorioCaracterizacaoPrint";
import "./relatoriocaracterizacaoGraudoPrint.css";

const peneirasPadrao = [
  "76,2",
  "63,5",
  "50,8",
  "38,1",
  "31,7",
  "25,4",
  "19,0",
  "12,5",
  "9,5",
  "6,3",
  "4,8",
  "2,4",
  "1,2",
  "0,6",
  "0,3",
  "0,15",
  "Fundo",
];

const granulometriaModelo = peneirasPadrao.map((peneira) => ({ peneira }));

const faixas = [
  ["- -", "- -", "- -", "- -", "0 - 5"],
  ["- -", "- -", "- -", "- -", "5 - 30"],
  ["- -", "- -", "- -", "0 - 5", "75 - 100"],
  ["- -", "- -", "- -", "5 - 30", "90 - 100"],
  ["- -", "- -", "0 - 5", "75 - 100", "95 - 100"],
  ["- -", "0 - 5", "5 - 25", "87 - 100", "- -"],
  ["- -", "2 - 15", "65 - 95", "95 - 100", "- -"],
  ["0 - 5", "40 - 65", "92 - 100", "- -", "- -"],
  ["2 - 15", "80 - 100", "95 - 100", "- -", "- -"],
  ["40 - 65", "92 - 100", "- -", "- -", "- -"],
  ["80 - 100", "95 - 100", "- -", "- -", "- -"],
  ["95 - 100", "- -", "- -", "- -", "- -"],
  ["- -", "- -", "- -", "- -", "- -"],
  ["- -", "- -", "- -", "- -", "- -"],
  ["- -", "- -", "- -", "- -", "- -"],
  ["- -", "- -", "- -", "- -", "- -"],
  ["", "", "", "", ""],
];

const britas = ["Brita 0", "Brita 1", "Brita 2", "Brita 3", "Brita 4"];
const toleranciasModuloFinura = ["5,77 / 6,15", "6,77 / 7,15", "7,6 / 7,45", "8,00 / 8,30", "8,90 / 9,05"];

const densidadeInicial = {
  materialSss1: "",
  materialSss2: "",
  frascoMaterial1: "",
  frascoMaterial2: "",
  frascoAgua1: "",
  frascoAgua2: "",
  pesoImerso1: "",
  pesoImerso2: "",
  volumeSss1: "",
  volumeSss2: "",
  volumeSeco1: "",
  volumeSeco2: "",
  materialSeco1: "",
  materialSeco2: "",
  densidadeSss1: "",
  densidadeSss2: "",
  densidadeSeco1: "",
  densidadeSeco2: "",
  densidadeMedia: "",
  absorcao1: "",
  absorcao2: "",
  absorcaoMedia: "",
};

const massaUnitariaInicial = {
  volume1: "",
  volume2: "",
  recipienteVazio1: "",
  recipienteVazio2: "",
  recipienteAgregado1: "",
  recipienteAgregado2: "",
  massaAgregado1: "",
  massaAgregado2: "",
  massaUnitaria1: "",
  massaUnitaria2: "",
  mediaMassaUnitaria: "",
};

const torroesPulverulentosInicial = {
  torroesAntes: "",
  torroesDepois: "",
  torroesPercentual: "",
  pulverulentosAntes: "",
  pulverulentosDepois: "",
  pulverulentosPercentual: "",
};

const abrasaoLosAngelesInicial = {
  massaInicial: "",
  massaFinal: "",
  graduacaoEnsaio: "",
  quantidadeEsferas: "",
  massaEsferas: "",
  abrasaoPercentual: "",
};

const peneirasIndiceForma = ["75,0", "63,0", "50,0", "37,5", "31,5", "25,0", "19,0", "12,5", "9,5"];

function criarGranulometriaIndiceForma() {
  return peneirasIndiceForma.map((abertura) => ({
    abertura,
    identificacao: "",
    massaRetida: "",
    massaRetidaManual: false,
    retidaPercentual: "",
    numeroGraos: "",
  }));
}

function criarMedicoesIndiceForma() {
  return Array.from({ length: 200 }, (_, index) => ({
    numero: index + 1,
    comprimento: "",
    espessura: "",
    relacao: "",
  }));
}

const indiceFormaInicial = {
  semEnsaio: true,
  data: "",
  resultado: "",
  resultadoManual: "",
  massaAlvo: "",
  granulometria: criarGranulometriaIndiceForma(),
  medicoes: criarMedicoesIndiceForma(),
  observacao: "",
};

function normalizarIndiceForma(dados = {}) {
  const granulometriaAtual = Array.isArray(dados.granulometria) ? dados.granulometria : [];
  const medicoesAtuais = Array.isArray(dados.medicoes) ? dados.medicoes : [];

  return {
    ...indiceFormaInicial,
    ...dados,
    granulometria: peneirasIndiceForma.map((abertura, index) => ({
      ...criarGranulometriaIndiceForma()[index],
      ...(granulometriaAtual[index] || {}),
      abertura,
    })),
    medicoes: criarMedicoesIndiceForma().map((linha, index) => ({
      ...linha,
      ...(medicoesAtuais[index] || {}),
      numero: index + 1,
    })),
  };
}

function calcularIndiceForma(dados = {}) {
  const normalizado = normalizarIndiceForma(dados);
  const medicoes = normalizado.medicoes.map((linha) => {
    const comprimento = numero(linha.comprimento);
    const espessura = numero(linha.espessura);
    const relacao = comprimento !== null && espessura > 0 ? comprimento / espessura : null;
    return {
      ...linha,
      relacao: relacao === null ? "" : relacao.toFixed(2).replace(".", ","),
    };
  });
  const medicoesValidas = medicoes.filter(
    (linha) => numero(linha.comprimento) !== null && numero(linha.espessura) > 0
  );
  const algumaMedicaoDigitada = medicoes.some(
    (linha) => valorPreenchido(linha.comprimento) || valorPreenchido(linha.espessura)
  );
  const resultadoManual = dados.resultadoManual !== undefined
    ? dados.resultadoManual
    : algumaMedicaoDigitada ? "" : dados.resultado || "";
  const totalGraosDistribuidos = normalizado.granulometria.reduce(
    (soma, linha) => soma + (numero(linha.numeroGraos) || 0),
    0
  );
  const distribuicaoGranulometricaConcluida =
    totalGraosDistribuidos === 200 &&
    normalizado.granulometria.some((linha) => linha.elegivel && numero(linha.numeroGraos) > 0);
  const todasMedicoesConcluidas = medicoesValidas.length === 200;
  const podeCalcularResultado = distribuicaoGranulometricaConcluida && todasMedicoesConcluidas;
  const comprimentoMedio = podeCalcularResultado
    ? medicoesValidas.reduce((soma, linha) => soma + numero(linha.comprimento), 0) / medicoesValidas.length
    : null;
  const espessuraMedia = podeCalcularResultado
    ? medicoesValidas.reduce((soma, linha) => soma + numero(linha.espessura), 0) / medicoesValidas.length
    : null;
  const resultado = comprimentoMedio !== null && espessuraMedia > 0
    ? (comprimentoMedio / espessuraMedia).toFixed(1).replace(".", ",")
    : algumaMedicaoDigitada ? "" : resultadoManual;

  return {
    ...normalizado,
    medicoes,
    comprimentoMedio: comprimentoMedio === null ? "" : comprimentoMedio.toFixed(2).replace(".", ","),
    espessuraMedia: espessuraMedia === null ? "" : espessuraMedia.toFixed(2).replace(".", ","),
    medicoesPreenchidas: medicoesValidas.length,
    algumaMedicaoDigitada,
    totalGraosDistribuidos,
    calculoConcluido: podeCalcularResultado,
    resultado,
    resultadoManual,
  };
}

function sincronizarIndiceFormaComGranulometria(dados = {}) {
  const indiceForma = calcularIndiceForma(dados.indiceForma || {});
  if (indiceForma.semEnsaio !== false) return { ...dados, indiceForma };
  const massaAlvoExistente = numero(indiceForma.massaAlvo);
  const massaAlvo = massaAlvoExistente !== null
    ? massaAlvoExistente
    : 5000 + Math.floor(Math.random() * 51) / 10;

  const linhasPrincipais = dados.granulometria || [];
  const fracoes = indiceForma.granulometria.map((linha) => {
    const principal = linhasPrincipais.find(
      (item) => numero(item.peneira) === numero(linha.abertura)
    );
    const massaA = numero(principal?.massaA);
    const massaB = numero(principal?.massaB);
    const massas = [massaA, massaB].filter((valor) => valor !== null);
    const massaRetida = massas.length
      ? massas.reduce((soma, valor) => soma + valor, 0) / massas.length
      : null;
    const percentual = numero(principal?.media);
    const elegivel = numero(linha.abertura) >= 9.5 && percentual !== null && percentual > 5;
    const massaRetidaManual = linha.massaRetidaManual === true && numero(linha.massaRetida) !== null;

    return {
      ...linha,
      massaRetida: massaRetidaManual
        ? linha.massaRetida
        : massaRetida === null ? "" : numeroBR(massaRetida, 1),
      massaRetidaManual,
      retidaPercentualOriginal: percentual === null ? "" : numeroBR(percentual, 1),
      elegivel,
      numeroGraos: "",
    };
  });

  const somaPercentuais = fracoes
    .filter((linha) => linha.elegivel)
    .reduce((soma, linha) => soma + numero(linha.retidaPercentualOriginal), 0);
  let granulometria = fracoes.map((linha) => {
    const quantidadeExata =
      linha.elegivel && somaPercentuais > 0
        ? (200 * numero(linha.retidaPercentualOriginal)) / somaPercentuais
        : 0;
    return {
    ...linha,
    retidaPercentual:
      linha.elegivel && somaPercentuais > 0
        ? numeroBR((100 * numero(linha.retidaPercentualOriginal)) / somaPercentuais, 1)
        : linha.retidaPercentualOriginal,
    numeroGraos:
      linha.elegivel && somaPercentuais > 0
        ? String(Math.round(quantidadeExata))
        : "0",
      quantidadeExata,
    };
  });

  const totalPercentualNormalizado = granulometria
    .filter((linha) => linha.elegivel)
    .reduce((soma, linha) => soma + (numero(linha.retidaPercentual) || 0), 0);
  const ajustePercentual = Number((100 - totalPercentualNormalizado).toFixed(1));
  if (somaPercentuais > 0 && ajustePercentual !== 0) {
    const indiceAjuste = granulometria.reduce(
      (melhor, linha, index) =>
        linha.elegivel && numero(linha.retidaPercentualOriginal) > numero(granulometria[melhor]?.retidaPercentualOriginal)
          ? index
          : melhor,
      0
    );
    granulometria = granulometria.map((linha, index) =>
      index === indiceAjuste
        ? { ...linha, retidaPercentual: numeroBR(numero(linha.retidaPercentual) + ajustePercentual, 1) }
        : linha
    );
  }

  granulometria = granulometria.map((linha) => ({
    ...linha,
    massaRetida: linha.massaRetidaManual
      ? linha.massaRetida
      : linha.elegivel
      ? numeroBR((massaAlvo * numero(linha.retidaPercentual)) / 100, 1)
      : linha.massaRetida !== "" ? "0,0" : "",
  }));

  let diferenca = 200 - granulometria.reduce((soma, linha) => soma + Number(linha.numeroGraos || 0), 0);
  while (diferenca !== 0) {
    const passo = diferenca > 0 ? 1 : -1;
    const candidatas = granulometria
      .map((linha, index) => ({ linha, index }))
      .filter(({ linha }) => linha.elegivel && (passo > 0 || Number(linha.numeroGraos) > 0))
      .sort((a, b) => {
        const custoA = Math.abs(Number(a.linha.numeroGraos) + passo - a.linha.quantidadeExata) - Math.abs(Number(a.linha.numeroGraos) - a.linha.quantidadeExata);
        const custoB = Math.abs(Number(b.linha.numeroGraos) + passo - b.linha.quantidadeExata) - Math.abs(Number(b.linha.numeroGraos) - b.linha.quantidadeExata);
        return custoA - custoB;
      });
    if (!candidatas.length) break;
    const indice = candidatas[0].index;
    granulometria = granulometria.map((linha, index) =>
      index === indice ? { ...linha, numeroGraos: String(Number(linha.numeroGraos) + passo) } : linha
    );
    diferenca -= passo;
  }
  granulometria = granulometria.map(({ quantidadeExata, ...linha }) => linha);

  return {
    ...dados,
    indiceForma: calcularIndiceForma({
      ...indiceForma,
      massaAlvo: numeroBR(massaAlvo, 1),
      granulometria,
    }),
  };
}

function processarIndiceFormaPorAmbiente(dados = {}) {
  if (AMBIENTE_PRODUCAO) return sincronizarIndiceFormaComGranulometria(dados);
  return {
    ...dados,
    indiceForma: calcularIndiceForma(dados.indiceForma || {}),
  };
}

const particulasLevesInicial = {
  data: "",
  teor: "",
  massaEspecificaSolucao: "2,00",
};

const saisCloretosSulfatosInicial = {
  data: "",
  teorCloretos: "",
  teorSulfatos: "",
  teorSais: "",
  observacao: "Realizado em laboratório parceiro",
};

const normaReferenciaInicial = {
  granulometria: "NBR 17054/2022 - Determinação da Composição Granulométrica",
  densidade: " – NBR NM 16917/2021 - Agregado Graúdo - Determinação da densidade e da absorção de água",
  massaUnitaria: "NBR 16972/2021 - Determinação da massa unitária e do índice de vazios;",
  materialPulverulento : " NBR 16973/2021 - Determinação do material fino que passa pela peneira de 75 µm por lavagem",
    torroesArgila: " NBR 7218/2025 - Determinação do teor de argila em torrões e materiais friáveis",
  abrasaoLosAngeles: "ABNT NBR 7211/2022 - Ensaio de desgaste por Abrasão “Los Angeles”",
  indiceForma: "ABNT NBR 7809/2019 - Agregado graúdo - Determinação do índice de forma pelo método do paquímetro",
  particulasLeves: "ABNT NBR 7211/2022 - Teor de Partículas Leves (Matérias Carbonosos)",
  saisCloretosSulfatos: "Determinação de Sais, Cloretos (Cl-) e Sulfatos Solúveis (SO42-)",
};

function formatarDataBR(dataISO) {
  if (!dataISO) return "-";
  const [ano, mes, dia] = String(dataISO).split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

function pareceAgregadoMiudo(dados) {
  const descricao = `${dados?.amostra || ""} ${dados?.descricao || ""} ${dados?.tipoMaterial || ""}`
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

  return /\b(areia|miudo|po de pedra)\b/.test(descricao);
}

function indiceBritaPorAmostra(amostra) {
  const texto = String(amostra || "").toLowerCase();
  const match = texto.match(/brita\s*([0-4])/);
  if (!match) return -1;
  return Number(match[1]);
}

function numero(valor) {
  if (valor === "" || valor === null || valor === undefined) return null;
  const texto = String(valor).trim();
  const temVirgula = texto.includes(",");
  const temPonto = texto.includes(".");
  const normalizado = temVirgula
    ? texto.replace(/\./g, "").replace(",", ".")
    : temPonto && /^\d{1,3}(\.\d{3})+$/.test(texto)
      ? texto.replace(/\./g, "")
      : texto;
  const n = Number(normalizado);
  return Number.isFinite(n) ? n : null;
}

function numeroBR(valor, casas = 1) {
  if (valor === "" || valor === null || valor === undefined) return "";
  const n = typeof valor === "number" ? valor : numero(valor);
  if (n === null) return "";
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

function valorPreenchido(valor) {
  if (valor === null || valor === undefined || valor === false) return false;
  return String(valor).trim() !== "";
}

function algumCampoPreenchido(objeto = {}, campos = [], valoresPadrao = {}) {
  return campos.some((campo) => {
    const valor = objeto[campo];
    if (
      Object.prototype.hasOwnProperty.call(valoresPadrao, campo) &&
      String(valor ?? "").trim() === String(valoresPadrao[campo]).trim()
    ) {
      return false;
    }
    return valorPreenchido(valor);
  });
}

function possuiGranulometriaPreenchida(dados) {
  return (
    valorPreenchido(dados.massaInicialA) ||
    valorPreenchido(dados.massaInicialB) ||
    (dados.granulometria || []).some((linha) =>
      ["massaA", "massaB", "retidaA", "retidaB", "acumulada"].some((campo) =>
        valorPreenchido(linha?.[campo])
      )
    )
  );
}

function ensaiosComDataPendente(dados) {
  const pendentes = [];

  if (possuiGranulometriaPreenchida(dados) && !valorPreenchido(dados.dataGranulometria)) {
    pendentes.push("granulometria");
  }
  if (algumCampoPreenchido(dados.densidade, Object.keys(densidadeInicial)) && !valorPreenchido(dados.dataDensidade)) {
    pendentes.push("densidade");
  }
  if (algumCampoPreenchido(dados.massaUnitaria, Object.keys(massaUnitariaInicial)) && !valorPreenchido(dados.dataMassaUnitaria)) {
    pendentes.push("massa unitária");
  }
  if (
    algumCampoPreenchido(dados.torroesPulverulentos, ["torroesAntes", "torroesDepois", "torroesPercentual"]) &&
    !valorPreenchido(dados.dataTorroesArgila)
  ) {
    pendentes.push("argila em torrões");
  }
  if (
    algumCampoPreenchido(dados.torroesPulverulentos, ["pulverulentosAntes", "pulverulentosDepois", "pulverulentosPercentual"]) &&
    !valorPreenchido(dados.dataMateriaisPulverulentos)
  ) {
    pendentes.push("material pulverulento");
  }
  if (
    algumCampoPreenchido(dados.abrasaoLosAngeles, Object.keys(abrasaoLosAngelesInicial)) &&
    !valorPreenchido(dados.dataAbrasaoLosAngeles)
  ) {
    pendentes.push("abrasão Los Angeles");
  }
  if (
    dados.indiceForma?.semEnsaio === false &&
    !valorPreenchido(dados.indiceForma?.data)
  ) {
    pendentes.push("índice de forma");
  }
  if (
    algumCampoPreenchido(
      dados.particulasLeves,
      ["teor", "massaEspecificaSolucao"],
      { massaEspecificaSolucao: particulasLevesInicial.massaEspecificaSolucao }
    ) &&
    !valorPreenchido(dados.particulasLeves?.data)
  ) {
    pendentes.push("partículas leves");
  }
  if (
    algumCampoPreenchido(dados.saisCloretosSulfatos, ["teorCloretos", "teorSulfatos", "teorSais"]) &&
    !valorPreenchido(dados.saisCloretosSulfatos?.data)
  ) {
    pendentes.push("sais, cloretos e sulfatos");
  }

  return pendentes;
}

function recalcularGranulometria(dados) {
  const massaInicialA = numero(dados.massaInicialA);
  const massaInicialB = numero(dados.massaInicialB);
  const possuiGranulometria = (dados.granulometria || []).some(
  (linha) =>
    numero(linha.massaA) !== null ||
    numero(linha.massaB) !== null
);
  let acumulada = 0;

  const granulometria = (dados.granulometria || []).map((linha) => {
    const massaA = numero(linha.massaA);
    const massaB = numero(linha.massaB);
    const retidaA =
      massaA !== null && massaInicialA ? (massaA / massaInicialA) * 100 : null;
    const retidaB =
      massaB !== null && massaInicialB ? (massaB / massaInicialB) * 100 : null;
    const valoresRetidos = [retidaA, retidaB].filter((valor) => valor !== null);
    const media =
      valoresRetidos.length > 0
        ? valoresRetidos.reduce((total, valor) => total + valor, 0) / valoresRetidos.length
        : null;
    const variacao =
      retidaA !== null && retidaB !== null ? Math.abs(retidaA - retidaB) : null;

    if (media !== null) acumulada += media;

    return {
      ...linha,
      retidaA: retidaA !== null ? numeroBR(retidaA, 1) : "",
      retidaB: retidaB !== null ? numeroBR(retidaB, 1) : "",
      variacao: variacao !== null ? numeroBR(variacao, 2) : "",
      media: media !== null ? numeroBR(media, 1) : "",
      acumulada: media !== null ? numeroBR(acumulada, 1) : "",
    };
  });
  const massasA = granulometria.map((linha) => numero(linha.massaA)).filter((valor) => valor !== null);
  const massasB = granulometria.map((linha) => numero(linha.massaB)).filter((valor) => valor !== null);
  const totalMassaANum = massasA.length
    ? massasA.reduce((total, valor) => total + valor, 0)
    : null;
  const totalMassaBNum = massasB.length
    ? massasB.reduce((total, valor) => total + valor, 0)
    : null;
  const diferencaMassaA =
    totalMassaANum !== null && massaInicialA ? ((massaInicialA - totalMassaANum) / massaInicialA) * 100 : null;
  const diferencaMassaB =
    totalMassaBNum !== null && massaInicialB ? ((massaInicialB - totalMassaBNum) / massaInicialB) * 100 : null;
  const diametroMaximo = possuiGranulometria
  ? calcularDiametroMaximo(granulometria)
  : "";

const moduloFinura = possuiGranulometria
  ? calcularModuloFinuraGraudo(granulometria)
  : "";

  return {
    ...dados,
    granulometria,
    totalMassaA: totalMassaANum !== null ? numeroBR(totalMassaANum, 1) : "",
    totalMassaB: totalMassaBNum !== null ? numeroBR(totalMassaBNum, 1) : "",
    diferencaMassaA: diferencaMassaA !== null ? numeroBR(diferencaMassaA, 2) : "",
    diferencaMassaB: diferencaMassaB !== null ? numeroBR(diferencaMassaB, 2) : "",
    diferencaMaxima: diametroMaximo,
    diametroMaximo,
    moduloFinura,
    tolerancias: toleranciasModuloFinura.join("  "),
  };
}

function recalcularDensidade(densidade) {
  const calcularEnsaio = (sufixo) => {
    const materialSss = numero(densidade[`materialSss${sufixo}`]);
    const frascoMaterial = numero(densidade[`frascoMaterial${sufixo}`]);
    const frascoAgua = numero(densidade[`frascoAgua${sufixo}`]);
    const materialSeco = numero(densidade[`materialSeco${sufixo}`]);
    const pesoImerso =
      frascoMaterial !== null && frascoAgua !== null ? frascoMaterial - frascoAgua : null;
    const volumeSss =
      materialSss !== null && pesoImerso !== null ? materialSss - pesoImerso : null;
    const volumeSeco =
      materialSeco !== null && pesoImerso !== null ? materialSeco - pesoImerso : null;

    return {
      [`pesoImerso${sufixo}`]: pesoImerso !== null ? numeroBR(pesoImerso, 1) : "",
      [`volumeSss${sufixo}`]: volumeSss !== null ? numeroBR(volumeSss, 1) : "",
      [`volumeSeco${sufixo}`]: volumeSeco !== null ? numeroBR(volumeSeco, 1) : "",
      [`densidadeSss${sufixo}`]:
        materialSss !== null && volumeSss ? numeroBR(materialSss / volumeSss, 3) : "",
      [`densidadeSeco${sufixo}`]:
        materialSeco !== null && volumeSss ? numeroBR(materialSeco / volumeSss, 3) : "",
      [`absorcao${sufixo}`]:
        materialSss !== null && materialSeco
          ? numeroBR(((materialSss - materialSeco) / materialSeco) * 100, 2)
          : "",
    };
  };

  const ensaio1 = calcularEnsaio("1");
  const ensaio2 = calcularEnsaio("2");
  const densidadeSss1 = numero(ensaio1.densidadeSss1);
  const densidadeSss2 = numero(ensaio2.densidadeSss2);
  const densidades = [densidadeSss1, densidadeSss2].filter((valor) => valor !== null);
  const absorcao1 = numero(ensaio1.absorcao1);
  const absorcao2 = numero(ensaio2.absorcao2);
  const absorcoes = [absorcao1, absorcao2].filter((valor) => valor !== null);

  return {
    ...densidade,
    ...ensaio1,
    ...ensaio2,
    densidadeMedia:
      densidades.length > 0
        ? numeroBR(densidades.reduce((total, valor) => total + valor, 0) / densidades.length, 3)
        : "",
    absorcaoMedia:
      absorcoes.length > 0
        ? numeroBR(absorcoes.reduce((total, valor) => total + valor, 0) / absorcoes.length, 2)
        : "",
  };
}

function recalcularMassaUnitaria(massaUnitaria) {
  const calcularEnsaio = (sufixo) => {
    const volume = numero(massaUnitaria[`volume${sufixo}`]);
    const recipienteVazio = numero(massaUnitaria[`recipienteVazio${sufixo}`]);
    const recipienteAgregado = numero(massaUnitaria[`recipienteAgregado${sufixo}`]);
    const massaAgregado =
      recipienteAgregado !== null && recipienteVazio !== null
        ? recipienteAgregado - recipienteVazio
        : null;
    const massaUnitariaCalculada =
      massaAgregado !== null && volume ? massaAgregado / volume : null;

    return {
      [`massaAgregado${sufixo}`]:
        massaAgregado !== null ? numeroBR(massaAgregado, 0) : "",
      [`massaUnitaria${sufixo}`]:
        massaUnitariaCalculada !== null ? numeroBR(massaUnitariaCalculada, 3) : "",
    };
  };

  const ensaio1 = calcularEnsaio("1");
  const ensaio2 = calcularEnsaio("2");
  const massaUnitaria1 = numero(ensaio1.massaUnitaria1);
  const massaUnitaria2 = numero(ensaio2.massaUnitaria2);
  const valores = [massaUnitaria1, massaUnitaria2].filter((valor) => valor !== null);

  return {
    ...massaUnitaria,
    ...ensaio1,
    ...ensaio2,
    mediaMassaUnitaria:
      valores.length > 0
        ? numeroBR(valores.reduce((total, valor) => total + valor, 0) / valores.length, 3)
        : "",
  };
}

function recalcularTorroesPulverulentos(torroesPulverulentos) {
  const calcularPercentual = (prefixo) => {
    const antes = numero(torroesPulverulentos[`${prefixo}Antes`]);
    const depois = numero(torroesPulverulentos[`${prefixo}Depois`]);
    const percentual =
      antes !== null && depois !== null && antes ? ((antes - depois) / antes) * 100 : null;

    return percentual !== null ? numeroBR(percentual, 1) : "";
  };

  return {
    ...torroesPulverulentos,
    torroesPercentual: calcularPercentual("torroes"),
    pulverulentosPercentual: calcularPercentual("pulverulentos"),
  };
}

function recalcularAbrasaoLosAngeles(abrasaoLosAngeles) {
  const massaInicial = numero(abrasaoLosAngeles.massaInicial);
  const massaFinal = numero(abrasaoLosAngeles.massaFinal);
  const abrasaoPercentual =
    massaInicial !== null && massaFinal !== null && massaInicial
      ? ((massaInicial - massaFinal) / massaInicial) * 100
      : null;

  return {
    ...abrasaoLosAngeles,
    abrasaoPercentual: abrasaoPercentual !== null ? numeroBR(abrasaoPercentual, 1) : "",
  };
}

function recalcularCaracterizacao(dados) {
  return recalcularGranulometria({
    ...dados,
    densidade: recalcularDensidade(dados.densidade || {}),
    massaUnitaria: recalcularMassaUnitaria(dados.massaUnitaria || {}),
    torroesPulverulentos: recalcularTorroesPulverulentos(dados.torroesPulverulentos || {}),
    abrasaoLosAngeles: recalcularAbrasaoLosAngeles(dados.abrasaoLosAngeles || {}),
  });
}

function calcularDiametroMaximo(granulometria) {
  const indiceFundo = granulometria.findIndex((linha) => String(linha.peneira || "").toLowerCase() === "fundo");
  const linhas = indiceFundo >= 0 ? granulometria.slice(0, indiceFundo) : granulometria;

  for (let index = 1; index < linhas.length; index += 1) {
    const acumulada = numero(linhas[index].acumulada);
    if (acumulada !== null && acumulada > 5) {
      return linhas[index - 1]?.peneira || "";
    }
  }

  return "";
}

function calcularModuloFinuraGraudo(granulometria) {
  const fundo = granulometria.find((linha) => String(linha.peneira || "").toLowerCase() === "fundo");
  if (numero(fundo?.acumulada) === null) return "";

  const peneirasModuloFinura = new Set([
    "76,2",
    "38,1",
    "19,0",
    "9,5",
    "4,8",
    "2,4",
    "1,2",
    "0,6",
    "0,3",
    "0,15",
  ]);

  let acumuladaAnterior = null;
  const somaAcumuladas = granulometria.reduce((total, linha) => {
    const acumuladaAtual = numero(linha.acumulada);
    if (acumuladaAtual !== null) acumuladaAnterior = acumuladaAtual;

    if (!peneirasModuloFinura.has(String(linha.peneira || ""))) return total;
    return total + (acumuladaAtual ?? acumuladaAnterior ?? 0);
  }, 0);

  return numeroBR(somaAcumuladas / 100, 1);
}

function ValorCelula({ children, destaque = false }) {
  return (
    <Typography
      sx={{
        color: destaque ? "primary.main" : "text.primary",
        fontSize: "0.82rem",
        fontWeight: destaque ? 700 : 500,
        minHeight: 30,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children || "-"}
    </Typography>
  );
}

function InfoCadastro({ label, value }) {
  return (
    <Box
      sx={{
        border: "1px solid #d9dde5",
        borderRadius: "8px",
        minHeight: 42,
        px: 1,
        py: 0.55,
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="caption" color="text.primary" fontWeight={700}>
        {label}:
      </Typography>
      <Typography
        color="text.secondary"
        sx={{
          mt: 0.35,
          lineHeight: 1.1,
          overflowWrap: "normal",
          whiteSpace: "nowrap",
          wordBreak: "normal",
        }}
      >
        {value || "-"}
      </Typography>
    </Box>
  );
}

function InfoCadastroSelect({ label, value, onChange, children }) {
  return (
    <Box
      sx={{
        border: "1px solid #d9dde5",
        borderRadius: "8px",
        minHeight: 42,
        px: 1,
        py: 0.55,
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="caption" color="text.primary" fontWeight={700}>
        {label}:
      </Typography>
      <TextField
        select
        value={value}
        onChange={onChange}
        size="small"
        variant="standard"
        fullWidth
        SelectProps={{ displayEmpty: true }}
        sx={{
          mt: 0.1,
          "& .MuiInputBase-root": { minHeight: 18, fontSize: "0.95rem" },
          "& .MuiSelect-select": { py: 0, color: "text.secondary" },
        }}
      >
        {children}
      </TextField>
    </Box>
  );
}

function CampoLocal({
  value,
  onCommit,
  onCommitAfter,
  onKeyDown,
  inputProps,
  sx,
  size = "small",
  ...props
}) {
  const [localValue, setLocalValue] = useState(value || "");

  useEffect(() => {
    setLocalValue(value || "");
  }, [value]);

  function commit() {
    const proximoValor = localValue || "";
    if (proximoValor !== (value || "")) {
      onCommit(proximoValor);
    }
    if (onCommitAfter) onCommitAfter();
  }

  return (
    <TextField
      {...props}
      size={size}
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      onBlur={commit}
      onKeyDown={onKeyDown}
      inputProps={inputProps}
      sx={sx}
    />
  );
}

const inputTabelaSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "3px",
  },
  "& .MuiInputBase-input": {
    p: "5px 2px",
    textAlign: "center",
    fontSize: "0.78rem",
  },
};

const celulaInputSx = {
  p: "1px",
  width: 72,
};

const MEDICOES_INDICE_FORMA_POR_COLUNA = 50;

export default function DetalhesCaracterizacao() {
  const { caracterizacaoId } = useParams();
  const history = useHistory();
  const [caracterizacao, setCaracterizacao] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [estadoOriginalEdicao, setEstadoOriginalEdicao] = useState("");
  const caracterizacaoOriginalRef = useRef(null);
  const [modoPrint, setModoPrint] = useState(false);
  const [modoRelatorio, setModoRelatorio] = useState(false);
  const [codigoRelatorio, setCodigoRelatorio] = useState("");
  const [dataRelatorio, setDataRelatorio] = useState("");
  const [relatorioSalvo, setRelatorioSalvo] = useState(false);
  const [salvandoRelatorio, setSalvandoRelatorio] = useState(false);
  const [ensaiosSolicitados, setEnsaiosSolicitados] = useState([]);
  const [restritoPorSolicitacao, setRestritoPorSolicitacao] = useState(false);
  const [alturaCabecalhoFixo, setAlturaCabecalhoFixo] = useState(94);
  const cabecalhoFixoRef = useRef(null);
  const [normaDialog, setNormaDialog] = useState({
    open: false,
    campo: "",
    valor: "",
  });

  useEffect(() => {
    carregarCaracterizacao();
  }, [caracterizacaoId]);

  useEffect(() => {
    const cabecalho = cabecalhoFixoRef.current;
    if (!cabecalho || modoPrint || modoRelatorio) return undefined;

    const atualizarAltura = () => {
      setAlturaCabecalhoFixo(Math.ceil(cabecalho.getBoundingClientRect().height));
    };
    atualizarAltura();

    const observador = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(atualizarAltura)
      : null;
    observador?.observe(cabecalho);
    window.addEventListener("resize", atualizarAltura);

    return () => {
      observador?.disconnect();
      window.removeEventListener("resize", atualizarAltura);
    };
  }, [caracterizacao?.id, modoPrint, modoRelatorio]);

  async function carregarCaracterizacao() {
    const snap = await getDoc(doc(db, "tblCaracterizacaoAgregados", caracterizacaoId));
    if (!snap.exists()) return;

    const dados = snap.data();
    const solicitacaoId = new URLSearchParams(window.location.search).get("solicitacaoId") || "";
    setRestritoPorSolicitacao(Boolean(solicitacaoId));
    if (solicitacaoId) {
      const solicitacaoSnap = await getDoc(doc(db, "tblSolicitacoesServicos", solicitacaoId));
      if (solicitacaoSnap.exists()) {
        setEnsaiosSolicitados(
          (solicitacaoSnap.data().ensaios || [])
            .map((ensaio) => ensaio.id)
            .filter((id) => String(id || "").startsWith("caracterizacao-"))
        );
      }
    } else {
      setEnsaiosSolicitados([]);
    }
    if (pareceAgregadoMiudo(dados)) {
      history.replace(`/app/cadastro-caracterizacao-miudo/${caracterizacaoId}`);
      return;
    }
    let codigoFornecedor = dados.codigoFornecedor || "";

    if (!codigoFornecedor && dados.fornecedorId) {
      const fornecedorSnap = await getDoc(doc(db, "tblListaMateriaisCadastrados", dados.fornecedorId));
      codigoFornecedor = fornecedorSnap.exists() ? fornecedorSnap.data()?.codigo || "" : "";
    }

    const caracterizacaoCarregada = processarIndiceFormaPorAmbiente(recalcularCaracterizacao({
      id: snap.id,
      ...dados,
      codigoFornecedor,
      granulometria: peneirasPadrao.map((peneira, index) => ({
        ...granulometriaModelo[index],
        ...(dados.granulometria?.[index] || {}),
        peneira,
      })),
      densidade: { ...densidadeInicial, ...(dados.densidade || {}) },
      massaUnitaria: { ...massaUnitariaInicial, ...(dados.massaUnitaria || {}) },
      torroesPulverulentos: {
        ...torroesPulverulentosInicial,
        ...(dados.torroesPulverulentos || {}),
      },
      abrasaoLosAngeles: {
        ...abrasaoLosAngelesInicial,
        ...(dados.abrasaoLosAngeles || {}),
      },
      indiceForma: {
        ...calcularIndiceForma(dados.indiceForma || {}),
      },
      particulasLeves: {
        ...particulasLevesInicial,
        ...(dados.particulasLeves || {}),
      },
      saisCloretosSulfatos: {
        ...saisCloretosSulfatosInicial,
        ...(dados.saisCloretosSulfatos || dados.sais || {}),
      },
      normaReferencia: {
        ...normaReferenciaInicial,
        ...(dados.normaReferencia || {}),
      },
      faixasAdicionais: Array.isArray(dados.faixasAdicionais) ? dados.faixasAdicionais : [],
    }));
    setCaracterizacao(caracterizacaoCarregada);
    caracterizacaoOriginalRef.current = caracterizacaoCarregada;
    setEstadoOriginalEdicao(JSON.stringify(caracterizacaoCarregada));
  }

  function atualizarCampo(campo, valor) {
    setMensagem("");
    setCaracterizacao((prev) => ({ ...prev, [campo]: valor }));
  }

  function atualizarGranulometria(index, campo, valor) {
    setMensagem("");
    setCaracterizacao((prev) => ({
      ...prev,
      granulometria: prev.granulometria.map((linha, linhaIndex) =>
        linhaIndex === index ? { ...linha, [campo]: valor } : linha
      ),
    }));
  }

  function atualizarGranulometriaERecalcular(index, campo, valor) {
    setMensagem("");
    setCaracterizacao((prev) =>
      processarIndiceFormaPorAmbiente(recalcularGranulometria({
        ...prev,
        granulometria: prev.granulometria.map((linha, linhaIndex) =>
          linhaIndex === index ? { ...linha, [campo]: valor } : linha
        ),
      }))
    );
  }

  function atualizarGrupo(grupo, campo, valor) {
    setMensagem("");
    setCaracterizacao((prev) => ({
      ...prev,
      [grupo]: {
        ...prev[grupo],
        [campo]: valor,
      },
    }));
  }

  function atualizarGrupoERecalcular(grupo, campo, valor) {
    setMensagem("");
    setCaracterizacao((prev) => {
      const grupoAtualizado = {
        ...prev[grupo],
        [campo]: valor,
      };

      return {
        ...prev,
        [grupo]: recalcularGrupo(grupo, grupoAtualizado),
      };
    });
  }

  function atualizarCampoERecalcular(campo, valor) {
    setMensagem("");
    setCaracterizacao((prev) => recalcularGranulometria({ ...prev, [campo]: valor }));
  }

  function recalcularGrupo(grupo, dadosGrupo) {
    if (grupo === "densidade") return recalcularDensidade(dadosGrupo || {});
    if (grupo === "massaUnitaria") return recalcularMassaUnitaria(dadosGrupo || {});
    if (grupo === "torroesPulverulentos") return recalcularTorroesPulverulentos(dadosGrupo || {});
    if (grupo === "abrasaoLosAngeles") return recalcularAbrasaoLosAngeles(dadosGrupo || {});
    return dadosGrupo || {};
  }

  function recalcularTela(grupo) {
    if (!grupo) {
      setCaracterizacao((prev) => recalcularCaracterizacao(prev));
      return;
    }

    setCaracterizacao((prev) => ({
      ...prev,
      [grupo]: recalcularGrupo(grupo, prev[grupo] || {}),
    }));
  }

  function abrirNormaReferencia(campo) {
    const normas = {
      ...normaReferenciaInicial,
      ...(caracterizacao.normaReferencia || {}),
    };
    setNormaDialog({
      open: true,
      campo,
      valor: normas[campo] || "",
    });
  }

  function fecharNormaReferencia() {
    setNormaDialog({ open: false, campo: "", valor: "" });
  }

  async function salvarNormaReferencia() {
    if (!normaDialog.campo) return;

    const normaReferencia = {
      ...normaReferenciaInicial,
      ...(caracterizacao.normaReferencia || {}),
      [normaDialog.campo]: normaDialog.valor,
    };

    try {
      const dadosSalvos = await atualizarDocumentoComMesclagem({
        db,
        referencia: doc(db, "tblCaracterizacaoAgregados", caracterizacao.id),
        original: caracterizacaoOriginalRef.current,
        atual: { ...caracterizacaoOriginalRef.current, normaReferencia },
        metadados: { atualizadoEm: new Date() },
      });
      caracterizacaoOriginalRef.current = { id: caracterizacao.id, ...dadosSalvos };
      setCaracterizacao((prev) => {
        const atualizado = { ...prev, normaReferencia };
        setEstadoOriginalEdicao(JSON.stringify(atualizado));
        return atualizado;
      });
      setMensagem("Norma de referência salva com sucesso!");
      fecharNormaReferencia();
    } catch (error) {
      console.error(error);
      setMensagem("Erro ao salvar norma de referência.");
    }
  }

  function handleEnterCelula(event, grupo, campo, index) {
    if (event.key !== "Enter") return;

    event.preventDefault();
    event.target.blur();

    const proximoCampo = grupo === "indiceForma" && campo === "espessura"
      ? "comprimento"
      : campo;
    const proximo = document.querySelector(
      `[data-caracterizacao-grupo='${grupo}'][data-caracterizacao-campo='${proximoCampo}'][data-caracterizacao-index='${index + 1}']`
    );

    if (proximo) proximo.focus();
  }

  function avancarCampoComEnter(event) {
    if (event.key !== "Enter") return;

    const campoAtual = event.target.closest("input, textarea, select, [contenteditable='true']");
    if (!campoAtual) return;

    event.preventDefault();

    const grupo = campoAtual.dataset.caracterizacaoGrupo;
    const campo = campoAtual.dataset.caracterizacaoCampo;
    const index = Number(campoAtual.dataset.caracterizacaoIndex);

    if (grupo === "indiceForma" && campo === "espessura" && Number.isInteger(index)) {
      const proximo = event.currentTarget.querySelector(
        `[data-caracterizacao-grupo='${grupo}'][data-caracterizacao-campo='comprimento'][data-caracterizacao-index='${index + 1}']`
      );

      campoAtual.blur();
      if (proximo) {
        proximo.focus();
        proximo.select?.();
      }
      return;
    }

    const campos = Array.from(
      event.currentTarget.querySelectorAll("input, textarea, select, [contenteditable='true']")
    ).filter((campo) => {
      const input = campo;
      return (
        input.type !== "hidden" &&
        !input.disabled &&
        !input.readOnly &&
        input.tabIndex !== -1 &&
        input.offsetParent !== null
      );
    });

    const indiceAtual = campos.indexOf(campoAtual);
    const proximoCampo = campos[indiceAtual + 1];

    campoAtual.blur();
    if (proximoCampo) {
      proximoCampo.focus();
      proximoCampo.select?.();
    }
  }

  function selecionarFaixaAdicional(indice) {
    const indiceNumerico = Number(indice);

    setCaracterizacao((prev) => {
      if (indice === "" || indiceNumerico === indiceBritaPorAmostra(prev.amostra)) {
        return {
          ...prev,
          faixasAdicionais: [],
        };
      }

      return {
        ...prev,
        faixasAdicionais: [indiceNumerico],
      };
    });
  }

  async function salvarTudo() {
    setSalvando(true);
    setMensagem("");

    try {
      const caracterizacaoRecalculada = processarIndiceFormaPorAmbiente(recalcularCaracterizacao({
        ...caracterizacao,
        indiceForma: calcularIndiceForma(caracterizacao.indiceForma || {}),
      }));
      const pendentesData = ensaiosComDataPendente(caracterizacaoRecalculada);
      if (pendentesData.length) {
        setMensagem(`É obrigatório o preenchimento da data em ensaios cadastrados: ${pendentesData.join(", ")}.`);
        return;
      }

      const indicePadrao = indiceBritaPorAmostra(caracterizacaoRecalculada.amostra);
      const faixasAdicionaisNormalizadas = Array.isArray(caracterizacaoRecalculada.faixasAdicionais)
        ? caracterizacaoRecalculada.faixasAdicionais
            .map((indice) => Number(indice))
            .filter((indice) => Number.isInteger(indice) && indice >= 0 && indice < britas.length)
            .filter((indice) => indice !== indicePadrao)
            .slice(0, 1)
        : [];
      const caracterizacaoParaSalvar = {
        ...caracterizacaoRecalculada,
        faixasAdicionais: faixasAdicionaisNormalizadas,
      };
      const { id } = caracterizacaoParaSalvar;
      const dadosSalvos = await atualizarDocumentoComMesclagem({
        db,
        referencia: doc(db, "tblCaracterizacaoAgregados", id),
        original: caracterizacaoOriginalRef.current,
        atual: caracterizacaoParaSalvar,
        preparar: (dadosMesclados) => {
          const { id: _id, ...dados } = dadosMesclados;
          return processarIndiceFormaPorAmbiente(recalcularCaracterizacao(dados));
        },
        metadados: { atualizadoEm: new Date() },
      });
      const caracterizacaoSalva = { id, ...dadosSalvos };
      setCaracterizacao(caracterizacaoSalva);
      caracterizacaoOriginalRef.current = caracterizacaoSalva;
      setEstadoOriginalEdicao(JSON.stringify(caracterizacaoSalva));
      setMensagem("Salvo com sucesso!");
    } catch (error) {
      console.error(error);
      setMensagem("Erro ao salvar dados.");
    } finally {
      setSalvando(false);
    }
  }

  if (!caracterizacao) return null;

  const temAlteracoes =
    Boolean(estadoOriginalEdicao) &&
    JSON.stringify(caracterizacao) !== estadoOriginalEdicao;

  async function cancelarAlteracoes() {
    if (!(await confirmarSistema("Deseja cancelar todas as alterações não salvas?"))) return;
    setMensagem("");
    await carregarCaracterizacao();
  }

  function atualizarMedicaoIndiceForma(index, campo, valor) {
    setMensagem("");
    setCaracterizacao((prev) => ({
      ...prev,
      indiceForma: calcularIndiceForma({
        ...prev.indiceForma,
        medicoes: normalizarIndiceForma(prev.indiceForma).medicoes.map((linha, linhaIndex) =>
          linhaIndex === index ? { ...linha, [campo]: valor } : linha
        ),
      }),
    }));
  }

  function atualizarMassaRetidaIndiceForma(index, valor) {
    setMensagem("");
    setCaracterizacao((prev) => ({
      ...prev,
      indiceForma: calcularIndiceForma({
        ...prev.indiceForma,
        granulometria: normalizarIndiceForma(prev.indiceForma).granulometria.map((linha, linhaIndex) =>
          linhaIndex === index
            ? { ...linha, massaRetida: valor, massaRetidaManual: true }
            : linha
        ),
      }),
    }));
  }

  function ensaioHabilitado(ensaioId) {
    return !restritoPorSolicitacao || ensaiosSolicitados.includes(ensaioId);
  }

  function numeroDoCodigoRelatorio(relatorio) {
    const codigo = String(relatorio?.codigoRelatorio || "").trim();
    const codigoPadrao = codigo.match(/^RE-CA-(\d+)(?:\.[A-Z0-9]+)?\/\d{4}$/i);
    return Number(relatorio?.codigoBase || relatorio?.numeroRelatorio || codigoPadrao?.[1] || codigo.split(".")[0] || 0);
  }

  function abrirRelatorio() {
    history.push("/app/relatorios/caracterizacao", {
      materialId: caracterizacao.id,
      abrirPrevia: true,
    });
  }

  async function salvarRelatorio() {
    if (relatorioSalvo || salvandoRelatorio) return;

    setSalvandoRelatorio(true);
    try {
      const relatoriosSnap = await getDocs(
        consultaTenantAtual(collection(db, "tblRelatoriosCaracterizacaoAgregados"))
      );
      const maiorNumeroExistente = relatoriosSnap.docs.reduce(
        (maior, item) => Math.max(maior, numeroDoCodigoRelatorio(item.data()) || 0),
        0
      );
      const sequencial = await gerarSequencial({
        chave: "relatorio_caracterizacao",
        valorMinimo: maiorNumeroExistente,
      });
      const codigoBase = String(sequencial.numero);
      const ano = String(dataRelatorio || new Date().toISOString().slice(0, 10)).slice(0, 4);
      const codigoGerado = `RE-CA-${codigoBase}/${ano}`;

      await addDoc(collection(db, "tblRelatoriosCaracterizacaoAgregados"), aplicarTenantAtual({
        clienteId: caracterizacao.clienteId || "",
        clienteNome: caracterizacao.clienteNome || caracterizacao.cliente || "",
        obraId: caracterizacao.obraId || "",
        obraNome: caracterizacao.obraNome || caracterizacao.obra || "",
        data: dataRelatorio || new Date().toISOString().slice(0, 10),
        materialIds: [caracterizacao.id],
        materiaisResumo: [{
          id: caracterizacao.id,
          codigo: caracterizacao.codigoFornecedor || caracterizacao.fornecedorCodigo || caracterizacao.codigoMaterial || caracterizacao.codigo || "",
          descricao: caracterizacao.amostra || caracterizacao.descricao || "",
          fornecedor: caracterizacao.procedencia || caracterizacao.fornecedor || "",
          tipoAgregado: "graudo",
        }],
        numeroRelatorio: Number(codigoBase),
        codigoRelatorio: codigoGerado,
        codigoBase,
        complementoCodigo: null,
        anexos: [],
        criadoEm: new Date(),
        atualizadoEm: new Date(),
      }));
      setCodigoRelatorio(codigoGerado);
      setRelatorioSalvo(true);
    } catch (error) {
      console.error(error);
      setMensagem("Erro ao salvar relatório.");
    } finally {
      setSalvandoRelatorio(false);
    }
  }

if (modoPrint) {
  return (
    <RelatorioCaracterizacaoGraudoPrint
      caracterizacao={caracterizacao}
      onVoltar={() => setModoPrint(false)}
    />
  );
}

if (modoRelatorio) {
  return (
    <RelatorioCaracterizacaoResumoPrint
      relatorio={{
        codigoRelatorio,
        data: dataRelatorio,
        clienteNome: caracterizacao.clienteNome || caracterizacao.cliente || "",
        obraNome: caracterizacao.obraNome || caracterizacao.obra || "",
        anexos: [],
      }}
      caracterizacoes={[
        {
          ...caracterizacao,
          tipoAgregado: "graudo",
        },
      ]}
      anexosEnsaios={[]}
      cliente={{
        nome: caracterizacao.clienteNome || caracterizacao.cliente || "",
      }}
      obra={{
        nome: caracterizacao.obraNome || caracterizacao.obra || "",
      }}
      autoPrint={false}
      onSalvar={relatorioSalvo ? undefined : salvarRelatorio}
      salvando={salvandoRelatorio}
      onVoltar={() => setModoRelatorio(false)}
    />
  );
}

  const indiceBritaSelecionada = indiceBritaPorAmostra(caracterizacao.amostra);
  const tipoAgregadoGrafico = "Graúdo";
  const faixasAdicionais = Array.isArray(caracterizacao.faixasAdicionais)
    ? caracterizacao.faixasAdicionais.filter((indice) => indice !== indiceBritaSelecionada)
    : [];
  const faixaAdicionalSelecionada = faixasAdicionais[0] ?? "";
  const densidadeLinhas = [
    ["A", "Material (sss)", "-", "materialSss1", "materialSss2", true],
    ["B", "Frasco+ Material (sss) + água", "-", "frascoMaterial1", "frascoMaterial2", true],
    ["C", "Frasco+ água", "-", "frascoAgua1", "frascoAgua2", true],
    ["D", "Peso do material imerso", "D = B - C", "pesoImerso1", "pesoImerso2"],
    ["E", "Massa de água deslocada (g)", "E = A - D", "volumeSss1", "volumeSss2"],
    ["F", "Massa de água equivalente ao volume real (g)", "F = G - D", "volumeSeco1", "volumeSeco2"],
    ["G", "Material seco estufa", "-", "materialSeco1", "materialSeco2", true],
    ["", "Densidades relativas (sem unidade)", "-", "", ""],
    ["H", "Densidade relativa do agregado (sss)", "H = A / E", "densidadeSss1", "densidadeSss2"],
    ["I", "Densidade relativa do agregado (seco)", "I = G / E", "densidadeSeco1", "densidadeSeco2"],
    ["J", "Densidade relativa média (sss)", "J = (H1 + H2) / 2", "densidadeMedia", ""],
    ["Ab)", "Absorção do agregado (%)", "[(A - G) / G] * 100", "absorcao1", "absorcao2"],
    ["", "Absorção Média (%)", "Média Ab", "absorcaoMedia", ""],
  ];
  const massaUnitariaLinhas = [
    ["-", "Determinações", "-", "1", "2"],
    ["A", "Volume do recipiente (dm3)", "-", "volume1", "volume2", true],
    ["B", "Massa do recipiente vazio g", "-", "recipienteVazio1", "recipienteVazio2", true],
    ["C", "Massa do recipiente + agregado g", "-", "recipienteAgregado1", "recipienteAgregado2", true],
    ["D", "Massa do agregado g", "D = C - B", "massaAgregado1", "massaAgregado2"],
    ["E", "M. unitária solta do agregado", "E = D / A", "massaUnitaria1", "massaUnitaria2"],
    ["F", "Média da massa unitária solta (g/cm3)", "F = (E1 + E2) / 2", "mediaMassaUnitaria", ""],
  ];

  const torroesPulverulentosLinhas = [
    ["antes", "torroesAntes", "pulverulentosAntes", true],
    ["depois", "torroesDepois", "pulverulentosDepois", true],
    ["%", "torroesPercentual", "pulverulentosPercentual"],
  ];
  const abrasaoLosAngelesLinhas = [
    ["Massa Inicial (g)", "massaInicial", true],
    ["Massa Final (g)", "massaFinal", true],
    ["Graduação do Ensaio", "graduacaoEnsaio", true],
    ["Quantidade de Esferas", "quantidadeEsferas", true],
    ["Massa das Esferas (g)", "massaEsferas", true],
    ["Abrasão Los Angeles (%)", "abrasaoPercentual"],
  ];

  function renderValorGrupo(grupo, campo, editavel, index) {
    const dados = caracterizacao[grupo] || {};
    if (!campo) return <ValorCelula>-</ValorCelula>;

    if (campo === "1" || campo === "2") {
      return <ValorCelula>{campo}</ValorCelula>;
    }

    if (!editavel) {
      return <ValorCelula destaque={campo.includes("Media") || campo.includes("media")}>{dados[campo]}</ValorCelula>;
    }

    return (
      <CampoLocal
        value={dados[campo] || ""}
        onCommit={(valor) => atualizarGrupoERecalcular(grupo, campo, valor)}
        onKeyDown={(event) => handleEnterCelula(event, grupo, campo, index)}
        inputProps={{
          "data-caracterizacao-grupo": grupo,
          "data-caracterizacao-campo": campo,
          "data-caracterizacao-index": index,
        }}
        sx={inputTabelaSx}
      />
    );
  }

  function renderTorroesPulverulentos() {
    return (
      <>
        {renderNormaReferencia("torroesArgila")}
        {renderNormaReferencia("materialPulverulento")}
        <Paper sx={{ p: 2, mb: 3, overflow: "auto" }}>
          <Table size="small" sx={{ minWidth: 560, tableLayout: "fixed" }}>
            <colgroup>
              <col style={{ width: 120 }} />
              <col style={{ width: 220 }} />
              <col style={{ width: 220 }} />
            </colgroup>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell />
                <TableCell align="center" sx={{ fontWeight: 700 }}>
                  Torr{"\u00f5"}es de argila
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 700 }}>
                  Pulverulento
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ fontWeight: 700 }}>Data:</TableCell>
                <TableCell sx={celulaInputSx}>
                  <CampoLocal
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={caracterizacao.dataTorroesArgila || ""}
                    onCommit={(valor) => atualizarCampo("dataTorroesArgila", valor)}
                    sx={inputTabelaSx}
                  />
                </TableCell>
                <TableCell sx={celulaInputSx}>
                  <CampoLocal
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={caracterizacao.dataMateriaisPulverulentos || ""}
                    onCommit={(valor) => atualizarCampo("dataMateriaisPulverulentos", valor)}
                    sx={inputTabelaSx}
                  />
                </TableCell>
              </TableRow>

              {torroesPulverulentosLinhas.map(([descricao, campoTorroes, campoPulverulentos, editavel], index) => (
                <TableRow key={descricao}>
                  <TableCell align="center">{descricao}</TableCell>
                  <TableCell sx={celulaInputSx}>
                    {renderValorGrupo("torroesPulverulentos", campoTorroes, editavel, index)}
                  </TableCell>
                  <TableCell sx={celulaInputSx}>
                    {renderValorGrupo("torroesPulverulentos", campoPulverulentos, editavel, index)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </>
    );
  }

  function renderAbrasaoLosAngeles() {
    return (
      <>
        {renderNormaReferencia("abrasaoLosAngeles")}
        <Paper sx={{ p: 2, mb: 3, overflow: "auto" }}>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography>Data do ensaio:</Typography>
            <CampoLocal
              type="date"
              InputLabelProps={{ shrink: true }}
              value={caracterizacao.dataAbrasaoLosAngeles || ""}
              onCommit={(valor) => atualizarCampo("dataAbrasaoLosAngeles", valor)}
              sx={{ ...inputTabelaSx, maxWidth: 180 }}
            />
          </Box>

          <Table size="small" sx={{ maxWidth: 720, tableLayout: "fixed" }}>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell align="center" sx={{ fontWeight: 700 }}>Graduação do Ensaio</TableCell>
                <TableCell align="center" sx={{ fontWeight: 700 }}>Abrasão “Los Angeles” (%)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {abrasaoLosAngelesLinhas.map(([descricao, campo, editavel], index) => (
                <TableRow key={campo}>
                  <TableCell align="center">{descricao}</TableCell>
                  <TableCell sx={celulaInputSx}>
                    {renderValorGrupo("abrasaoLosAngeles", campo, editavel, index)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Typography sx={{ mt: 2 }}>
            A ABNT NBR 7211/2022 especifica o limite máximo de 50% para a Abrasão “Los Angeles”, considerando o emprego do agregado graúdo na produção dos concretos.
          </Typography>
        </Paper>
      </>
    );
  }

  function renderIndiceForma() {
    const semEnsaio = caracterizacao.indiceForma?.semEnsaio ?? true;
    const indiceForma = calcularIndiceForma(caracterizacao.indiceForma || {});
    const totalMassa = indiceForma.granulometria
      .map((linha) => numero(linha.massaRetida))
      .filter((valor) => valor !== null)
      .reduce((soma, valor) => soma + valor, 0);
    const totalGraos = indiceForma.granulometria
      .map((linha) => numero(linha.numeroGraos))
      .filter((valor) => valor !== null)
      .reduce((soma, valor) => soma + valor, 0);
    const totalPercentual = indiceForma.granulometria
      .filter((linha) => linha.elegivel)
      .map((linha) => numero(linha.retidaPercentual))
      .filter((valor) => valor !== null)
      .reduce((soma, valor) => soma + valor, 0);
    const gruposMedicoes = Array.from({ length: 4 }, (_, grupoIndex) => {
      const inicio = grupoIndex * MEDICOES_INDICE_FORMA_POR_COLUNA;
      return indiceForma.medicoes.slice(inicio, inicio + MEDICOES_INDICE_FORMA_POR_COLUNA);
    });

    return (
      <>
        {renderNormaReferencia("indiceForma")}
        <Paper sx={{ p: 2, mb: 3 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={semEnsaio}
                onChange={(event) => {
                  setCaracterizacao((prev) =>
                    processarIndiceFormaPorAmbiente({
                      ...prev,
                      indiceForma: calcularIndiceForma({
                        ...prev.indiceForma,
                        semEnsaio: event.target.checked,
                      }),
                    })
                  );
                }}
              />
            }
            label="Não possui ensaio de índice de forma"
          />

          {!semEnsaio && (
            <Box mt={2}>
              <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "220px" }} gap={2} mb={2}>
              <CampoLocal
                label="Data do ensaio"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={caracterizacao.indiceForma?.data || ""}
                onCommit={(valor) => atualizarGrupo("indiceForma", "data", valor)}
              />
              </Box>

              <Typography fontWeight={700} textAlign="center" mb={1}>GRANULOMETRIA</Typography>
              <Box sx={{ overflowX: "auto", mb: 2 }}>
                <Table size="small" sx={{ minWidth: 760, tableLayout: "fixed" }}>
                  <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                    <TableRow>
                      <TableCell align="center">Abertura (mm)</TableCell>
                      <TableCell align="center">Identificação</TableCell>
                      <TableCell align="center">Massa retida (g)</TableCell>
                      <TableCell align="center">Retida (%)</TableCell>
                      <TableCell align="center">Número de grãos medidos</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {indiceForma.granulometria.map((linha, index) => (
                      <TableRow key={linha.abertura}>
                        <TableCell align="center">{linha.abertura}</TableCell>
                        <TableCell align="center">{linha.identificacao || "-"}</TableCell>
                        <TableCell sx={celulaInputSx}>
                          <CampoLocal
                            value={linha.massaRetida || ""}
                            onCommit={(valor) => atualizarMassaRetidaIndiceForma(index, valor)}
                            sx={inputTabelaSx}
                          />
                        </TableCell>
                        <TableCell align="center">{linha.retidaPercentual || "-"}</TableCell>
                        <TableCell align="center" sx={{ fontWeight: linha.elegivel ? 700 : 400 }}>
                          {linha.numeroGraos || "0"}
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell colSpan={2} align="center" sx={{ fontWeight: 700 }}>TOTAL</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 700 }}>{totalMassa ? totalMassa.toFixed(1).replace(".", ",") : "-"}</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 700 }}>{totalPercentual ? numeroBR(totalPercentual, 1) : "-"}</TableCell>
                      <TableCell align="center" sx={{ fontWeight: 700 }}>{totalGraos || "-"}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
              <Typography variant="caption" color="text.secondary" display="block" mb={2}>
                Conforme a ABNT NBR 7809: são desconsiderados o material passante na peneira de 9,5 mm e as frações com retenção individual igual ou inferior a 5%. A quantidade de grãos é distribuída proporcionalmente para um total nominal de 200.
                {indiceForma.massaAlvo ? ` Massa-alvo gerada: ${indiceForma.massaAlvo} g.` : ""}
              </Typography>

              <Typography fontWeight={700} textAlign="center" mb={1}>MEDIÇÕES DOS GRÃOS</Typography>
              <Box sx={{ overflowX: "auto" }}>
                <Table size="small" sx={{ minWidth: 1440, tableLayout: "fixed" }}>
                  <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                    <TableRow>
                      {[0, 1, 2, 3].map((grupo) => (
                        <React.Fragment key={grupo}>
                          <TableCell align="center">Nº</TableCell>
                          <TableCell align="center">Comprimento</TableCell>
                          <TableCell align="center">Espessura</TableCell>
                          <TableCell align="center">c/e</TableCell>
                        </React.Fragment>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Array.from({ length: MEDICOES_INDICE_FORMA_POR_COLUNA }, (_, linhaIndex) => (
                      <TableRow key={linhaIndex}>
                        {gruposMedicoes.map((grupo, grupoIndex) => {
                          const medicao = grupo[linhaIndex];
                          if (!medicao) return <TableCell key={grupoIndex} colSpan={4} />;
                          const indiceReal = grupoIndex * MEDICOES_INDICE_FORMA_POR_COLUNA + linhaIndex;
                          return (
                            <React.Fragment key={medicao.numero}>
                              <TableCell align="center" sx={{ fontWeight: 700, width: 44 }}>{String(medicao.numero).padStart(3, "0")}</TableCell>
                              <TableCell sx={celulaInputSx}><CampoLocal value={medicao.comprimento || ""} onCommit={(valor) => atualizarMedicaoIndiceForma(indiceReal, "comprimento", valor)} onKeyDown={(event) => handleEnterCelula(event, "indiceForma", "comprimento", indiceReal)} inputProps={{ "data-caracterizacao-grupo": "indiceForma", "data-caracterizacao-campo": "comprimento", "data-caracterizacao-index": indiceReal }} sx={inputTabelaSx} /></TableCell>
                              <TableCell sx={celulaInputSx}><CampoLocal value={medicao.espessura || ""} onCommit={(valor) => atualizarMedicaoIndiceForma(indiceReal, "espessura", valor)} onKeyDown={(event) => handleEnterCelula(event, "indiceForma", "espessura", indiceReal)} inputProps={{ "data-caracterizacao-grupo": "indiceForma", "data-caracterizacao-campo": "espessura", "data-caracterizacao-index": indiceReal }} sx={inputTabelaSx} /></TableCell>
                              <TableCell align="center">{medicao.relacao || "-"}</TableCell>
                            </React.Fragment>
                          );
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>

              <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "180px 180px 180px 1fr" }} gap={2} mt={2}>
                <TextField label="Comprimento médio (mm)" value={indiceForma.comprimentoMedio || ""} InputProps={{ readOnly: true }} size="small" />
                <TextField label="Espessura média (mm)" value={indiceForma.espessuraMedia || ""} InputProps={{ readOnly: true }} size="small" />
                <CampoLocal label="Resultado" value={indiceForma.resultado || ""} onCommit={(valor) => atualizarGrupo("indiceForma", "resultadoManual", valor)} InputProps={{ readOnly: indiceForma.algumaMedicaoDigitada }} inputProps={{ inputMode: "decimal" }} />
                <CampoLocal label="Observação" value={indiceForma.observacao || ""} onCommit={(valor) => atualizarGrupo("indiceForma", "observacao", valor)} />
              </Box>
              {!indiceForma.calculoConcluido && (
                <Typography variant="caption" color="text.secondary" display="block" mt={1}>
                  Cálculo aguardando: {indiceForma.medicoesPreenchidas || 0}/200 pedras preenchidas e {indiceForma.totalGraosDistribuidos || 0}/200 grãos distribuídos pela granulometria.
                </Typography>
              )}
            </Box>
          )}
        </Paper>
      </>
    );
  }

  function renderParticulasLeves() {
    const dados = caracterizacao.particulasLeves || {};

    return (
      <>
        {renderNormaReferencia("particulasLeves")}
        <Paper sx={{ p: 2, mb: 3, overflow: "auto" }}>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography>Data do ensaio:</Typography>
            <CampoLocal
              type="date"
              InputLabelProps={{ shrink: true }}
              value={dados.data || ""}
              onCommit={(valor) => atualizarGrupo("particulasLeves", "data", valor)}
              sx={{ ...inputTabelaSx, maxWidth: 180 }}
            />
          </Box>

          <Table size="small" sx={{ maxWidth: 820, tableLayout: "fixed" }}>
            <TableBody>
              <TableRow>
                <TableCell align="center">TEOR DE PARTÍCULAS LEVES (%)</TableCell>
                <TableCell sx={celulaInputSx}>
                  <CampoLocal
                    value={dados.teor || ""}
                    onCommit={(valor) => atualizarGrupo("particulasLeves", "teor", valor)}
                    sx={inputTabelaSx}
                  />
                </TableCell>
                <TableCell align="center">Massa Específica da Solução do ensaio</TableCell>
                <TableCell sx={celulaInputSx}>
                  <CampoLocal
                    value={dados.massaEspecificaSolucao || ""}
                    onCommit={(valor) => atualizarGrupo("particulasLeves", "massaEspecificaSolucao", valor)}
                    sx={inputTabelaSx}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell rowSpan={3} align="center">
                  Quantidade Máxima Relativa à Massa do Agregado (%)
                </TableCell>
                <TableCell colSpan={3} align="center">Limites: NBR 7211/09 - ASTM 123</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2} align="center">Concreto Aparente</TableCell>
                <TableCell align="center">0,5</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2} align="center">Concreto Não Aparente</TableCell>
                <TableCell align="center">1,0</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Typography sx={{ mt: 2 }}>
            A amostra analisada atende as especificações da ABNT NBR 7211/2022 quanto os ensaios realizados para Teor de partículas leves (materiais carbonosos).
          </Typography>
        </Paper>
      </>
    );
  }

  function renderSaisCloretosSulfatos() {
    const dados = caracterizacao.saisCloretosSulfatos || {};

    return (
      <>
        {renderNormaReferencia("saisCloretosSulfatos")}
        <Paper sx={{ p: 2, mb: 3, overflow: "auto" }}>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography>Data conclusão:</Typography>
            <CampoLocal
              type="date"
              InputLabelProps={{ shrink: true }}
              value={dados.data || ""}
              onCommit={(valor) => atualizarGrupo("saisCloretosSulfatos", "data", valor)}
              sx={{ ...inputTabelaSx, maxWidth: 180 }}
            />
          </Box>

          <Table size="small" sx={{ maxWidth: 820, tableLayout: "fixed" }}>
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow><TableCell colSpan={3} align="center">ENSAIOS</TableCell></TableRow>
              <TableRow>
                <TableCell align="center">TEOR DE CLORETOS (%)</TableCell>
                <TableCell align="center">TEOR DE SULFATOS (%)</TableCell>
                <TableCell align="center">TEOR DE SAIS</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={celulaInputSx}>
                  <CampoLocal value={dados.teorCloretos || ""} onCommit={(valor) => atualizarGrupo("saisCloretosSulfatos", "teorCloretos", valor)} sx={inputTabelaSx} />
                </TableCell>
                <TableCell sx={celulaInputSx}>
                  <CampoLocal value={dados.teorSulfatos || ""} onCommit={(valor) => atualizarGrupo("saisCloretosSulfatos", "teorSulfatos", valor)} sx={inputTabelaSx} />
                </TableCell>
                <TableCell sx={celulaInputSx}>
                  <CampoLocal value={dados.teorSais || ""} onCommit={(valor) => atualizarGrupo("saisCloretosSulfatos", "teorSais", valor)} sx={inputTabelaSx} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="center">LIMITE NORMATIVO (CLORETO)</TableCell>
                <TableCell colSpan={2} align="center">&lt;0,2% para concreto simples, &lt;0,1 para concreto armado e &lt;0,01% para concreto protendido.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="center">LIMITE NORMATIVO (SULFATO)</TableCell>
                <TableCell colSpan={2} align="center">&lt;0,1%</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <CampoLocal
            label="Observação"
            value={dados.observacao || ""}
            onCommit={(valor) => atualizarGrupo("saisCloretosSulfatos", "observacao", valor)}
            fullWidth
            sx={{ mt: 2 }}
          />
        </Paper>
      </>
    );
  }

  function renderNormaReferencia(campo) {
    const normas = {
      ...normaReferenciaInicial,
      ...(caracterizacao.normaReferencia || {}),
    };

    return (
      <Typography
        onClick={() => abrirNormaReferencia(campo)}
        sx={{
          mb: 1,
          ml: 1.5,
          color: "text.primary",
          cursor: "pointer",
          fontSize: "0.95rem",
          fontWeight: 500,
          "&:hover": { color: "primary.main", textDecoration: "underline" },
        }}
      >
        {normas[campo] || "-"}
      </Typography>
    );
  }

 const botoesAcao = (
  <Box display="flex" justifyContent="flex-end" gap={2}>
    <Button
      variant="outlined"
      onClick={() => setModoPrint(true)}
      disabled={salvando || temAlteracoes}
    >
      Visualizar
    </Button>

    <Button
      variant="contained"
      color="secondary"
      onClick={abrirRelatorio}
      disabled={salvando || temAlteracoes}
    >
      Relatório
    </Button>

    <Button
      variant="outlined"
      onClick={() => history.goBack()}
      disabled={salvando || temAlteracoes}
    >
      Voltar
    </Button>

    {temAlteracoes && (
      <>
        <Button
          variant="contained"
          onClick={salvarTudo}
          disabled={salvando}
        >
          {salvando ? "Salvando..." : "Salvar"}
        </Button>
        <Button data-confirmacao-cancelamento="propria" variant="outlined" onClick={cancelarAlteracoes} disabled={salvando}>
          Cancelar alterações
        </Button>
      </>
    )}
  </Box>
);

  const granulometriaHabilitada =
    ensaioHabilitado("caracterizacao-granulometria") ||
    (AMBIENTE_PRODUCAO && caracterizacao.indiceForma?.semEnsaio === false);

  return (
    <>
      <Navbar />
      <Box
        ref={cabecalhoFixoRef}
        sx={{
          position: "fixed",
          top: { xs: 68, md: 76 },
          left: { xs: 12, md: 24 },
          right: { xs: 12, md: 24 },
          zIndex: 1190,
        }}
      >
        <CabecalhoDetalhes
          titulo="Caracterização de Agregados"
          subtitulo="RQ 2.2.3-A   Rev.00 - 20/08/2025"
          sx={{ position: "static", top: "auto", zIndex: "auto", mx: 0, mt: 0 }}
        >
          {botoesAcao}
        </CabecalhoDetalhes>
      </Box>

      <Box aria-hidden="true" sx={{ height: `${alturaCabecalhoFixo + 12}px` }} />

      <Box sx={{ p: { xs: 2, md: 4 } }} component="form" autoComplete="off" onKeyDownCapture={avancarCampoComEnter}>
        {mensagem && (
          <Alert severity={mensagem.includes("sucesso") ? "success" : "error"} sx={{ mb: 2 }}>
            {mensagem}
          </Alert>
        )}


        <Paper sx={{ p: 2, mb: 3 }}>
          <Typography fontWeight={700} mb={2}>
            DADOS DO CADASTRO
          </Typography>

          <Box
            display="grid"
            gridTemplateColumns={{
              xs: "1fr",
              md: "1fr 1fr 2fr",
              lg: "1fr 1fr 2fr 2fr",
            }}
            gap={1}
          >
            <InfoCadastro label="CÓDIGO" value={caracterizacao.codigo} />
            <InfoCadastro label="CADASTRO" value={formatarDataBR(caracterizacao.dataCadastro || caracterizacao.criadoEm?.toDate?.()?.toISOString?.()?.slice(0, 10))} />
            <InfoCadastro label="AMOSTRA" value={caracterizacao.amostra} />
            <InfoCadastro label="PROCEDÊNCIA" value={caracterizacao.procedencia} />
            <InfoCadastro label="LOCAL DA COLETA" value={caracterizacao.localColeta} />
            <InfoCadastro label="FAIXA PADRÃO" value={britas[indiceBritaSelecionada]} />
            <InfoCadastroSelect
              label="FAIXA ADICIONAL"
              value={faixaAdicionalSelecionada}
              onChange={(e) => selecionarFaixaAdicional(e.target.value)}
            >
              <MenuItem value="">-</MenuItem>
              {britas.map((brita, index) => index === indiceBritaSelecionada ? null : (
                <MenuItem key={brita} value={index}>
                  {brita}
                </MenuItem>
              ))}
            </InfoCadastroSelect>
          </Box>
        </Paper>

        <fieldset disabled={!granulometriaHabilitada} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, opacity: granulometriaHabilitada ? 1 : 0.45 }}>
        {renderNormaReferencia("granulometria")}
        <Paper sx={{ p: 2, mb: 3 }}>
          <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "repeat(4, 1fr)" }} gap={2} mb={2}>
  <CampoLocal
    label="Data"
    type="date"
    value={caracterizacao.dataGranulometria || ""}
    onCommit={(valor) => atualizarCampo("dataGranulometria", valor)}
    InputLabelProps={{ shrink: true }}
  />
  <CampoLocal label="Operador" value={caracterizacao.operadorGranulometria || ""} onCommit={(valor) => atualizarCampo("operadorGranulometria", valor)} />
  <CampoLocal label="Massa inicial A" value={caracterizacao.massaInicialA || ""} onCommit={(valor) => atualizarCampoERecalcular("massaInicialA", valor)} />
  <CampoLocal label="Massa inicial B" value={caracterizacao.massaInicialB || ""} onCommit={(valor) => atualizarCampoERecalcular("massaInicialB", valor)} />
</Box>

          <Box sx={{ overflowX: "auto" }}>
            <Table size="small" sx={{ minWidth: 1240 }}>
              <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                <TableRow>
                  <TableCell rowSpan={2} align="center">Abertura das<br />Peneiras<br />(mm)</TableCell>
                  <TableCell colSpan={2} align="center">Massa retida (g)</TableCell>
                  <TableCell colSpan={2} align="center">Massa retida (%)</TableCell>
                  <TableCell rowSpan={2} align="center">Variação<br />+- 4 %</TableCell>
                  <TableCell rowSpan={2} align="center">Média<br />(%)</TableCell>
                  <TableCell rowSpan={2} align="center">Acumulada<br />(%)</TableCell>
                  <TableCell colSpan={5} align="center">
                    Faixas em relação as % retidas acumuladas NBR 7211
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">Ensaio a</TableCell>
                  <TableCell align="center">Ensaio b</TableCell>
                  <TableCell align="center">Ensaio a</TableCell>
                  <TableCell align="center">Ensaio b</TableCell>
                  {britas.map((brita, britaIndex) => (
                    <TableCell
                      key={brita}
                      align="center"
                      sx={{
                        fontWeight: britaIndex === indiceBritaSelecionada ? 700 : 500,
                        backgroundColor:
                          britaIndex === indiceBritaSelecionada ? "#e3f2fd" : "transparent",
                      }}
                    >
                      {brita}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {caracterizacao.granulometria.map((linha, index) => (
                  <TableRow key={linha.peneira}>
                    <TableCell align="center" sx={{ width: 74 }}>{linha.peneira}</TableCell>
                    {["massaA", "massaB"].map((campo) => (
                      <TableCell key={campo} sx={celulaInputSx}>
                        <CampoLocal
                          value={linha[campo] || ""}
                          onCommit={(valor) => atualizarGranulometriaERecalcular(index, campo, valor)}
                          onKeyDown={(event) => handleEnterCelula(event, "granulometria", campo, index)}
                          inputProps={{
                            "data-caracterizacao-grupo": "granulometria",
                            "data-caracterizacao-campo": campo,
                            "data-caracterizacao-index": index,
                          }}
                          sx={inputTabelaSx}
                        />
                      </TableCell>
                    ))}
                    {["retidaA", "retidaB", "variacao", "media", "acumulada"].map((campo) => (
                      <TableCell key={campo} sx={{ p: "3px", width: 72 }}>
                        <ValorCelula destaque={campo === "acumulada"}>
                          {linha[campo]}
                        </ValorCelula>
                      </TableCell>
                    ))}
                    {faixas[index].map((faixa, faixaIndex) => (
                      <TableCell
                        key={faixaIndex}
                        align="center"
                        sx={{
                          width: 72,
                          fontWeight: faixaIndex === indiceBritaSelecionada ? 700 : 400,
                          backgroundColor:
                            faixaIndex === indiceBritaSelecionada ? "#e3f2fd" : "transparent",
                        }}
                      >
                        {faixa}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Total</TableCell>
                  <TableCell align="center">{caracterizacao.totalMassaA}</TableCell>
                  <TableCell align="center">{caracterizacao.totalMassaB}</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Ø máx.</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 700 }}>
                    {caracterizacao.diferencaMaxima}
                  </TableCell>
                  <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
                    Módulo de finura
                  </TableCell>
                  <TableCell align="center" sx={{ color: "#d00 !important", fontWeight: 700 }}>
                    {caracterizacao.moduloFinura}
                  </TableCell>
                  {toleranciasModuloFinura.map((tolerancia) => (
                    <TableCell key={tolerancia} align="center">
                      {tolerancia}
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>diferença</TableCell>
                  <TableCell align="center">{caracterizacao.diferencaMassaA}</TableCell>
                  <TableCell align="center">{caracterizacao.diferencaMassaB}</TableCell>
                  <TableCell colSpan={10} />
                </TableRow>
              </TableBody>
            </Table>
          </Box>

          <Box className="relatorio-caracterizacao-print" sx={{ mt: 2 }}>
            <ChartGranulometria
              linhas={caracterizacao.granulometria}
              amostra={caracterizacao.amostra}
              tipoAgregado={tipoAgregadoGrafico}
              faixasAdicionais={faixasAdicionais}
            />
          </Box>

        </Paper>

        </fieldset>
        <fieldset disabled={!ensaioHabilitado("caracterizacao-densidade-absorcao")} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, opacity: ensaioHabilitado("caracterizacao-densidade-absorcao") ? 1 : 0.45 }}>
        {renderNormaReferencia("densidade")}
        <Paper sx={{ p: 2, mb: 3, overflow: "auto" }}>
          <Table size="small" sx={{ minWidth: 900, tableLayout: "fixed" }}>
            <colgroup>
              <col style={{ width: 42 }} />
              <col style={{ width: 300 }} />
              <col style={{ width: 120 }} />
              <col style={{ width: 145 }} />
              <col style={{ width: 145 }} />
            </colgroup>
            <TableBody>
              <TableRow sx={{ backgroundColor: "#f8fafc" }}>
                <TableCell sx={{ fontWeight: 700 }}>Data:</TableCell>
                <TableCell>
                  <CampoLocal
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={caracterizacao.dataDensidade || ""}
                    onCommit={(valor) => atualizarCampo("dataDensidade", valor)}
                    sx={inputTabelaSx}
                  />
                </TableCell>
                <TableCell />
                <TableCell sx={{ fontWeight: 700 }}>OPERADOR:</TableCell>
                <TableCell>
                  <CampoLocal
                    value={caracterizacao.operadorDensidade || ""}
                    onCommit={(valor) => atualizarCampo("operadorDensidade", valor)}
                    sx={inputTabelaSx}
                  />
                </TableCell>
              </TableRow>

              {densidadeLinhas.map(([letra, descricao, formula, campo1, campo2, editavel], index) => (
                <TableRow key={`${letra}-${descricao}`}>
                  <TableCell align="center" sx={{ width: 42 }}>{letra}</TableCell>
                  <TableCell>{descricao}</TableCell>
                  <TableCell align="center">{formula}</TableCell>
                  {campo1 === "densidadeMedia" || campo1 === "absorcaoMedia" ? (
                    <TableCell colSpan={2} sx={celulaInputSx}>
                      {renderValorGrupo("densidade", campo1, editavel, index)}
                    </TableCell>
                  ) : (
                    <>
                      <TableCell sx={celulaInputSx}>
                        {renderValorGrupo("densidade", campo1, editavel, index)}
                      </TableCell>
                      <TableCell sx={celulaInputSx}>
                        {renderValorGrupo("densidade", campo2, editavel, index)}
                      </TableCell>
                    </>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>

        </fieldset>
        <fieldset disabled={!ensaioHabilitado("caracterizacao-massa-unitaria")} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, opacity: ensaioHabilitado("caracterizacao-massa-unitaria") ? 1 : 0.45 }}>
        {renderNormaReferencia("massaUnitaria")}
        <Paper sx={{ p: 2, mb: 3, overflow: "auto" }}>
          <Table size="small" sx={{ minWidth: 900, tableLayout: "fixed" }}>
            <colgroup>
              <col style={{ width: 42 }} />
              <col style={{ width: 300 }} />
              <col style={{ width: 120 }} />
              <col style={{ width: 145 }} />
              <col style={{ width: 145 }} />
            </colgroup>
            <TableBody>
              <TableRow sx={{ backgroundColor: "#f8fafc" }}>
                <TableCell sx={{ fontWeight: 700 }}>Data:</TableCell>
                <TableCell>
                  <CampoLocal
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={caracterizacao.dataMassaUnitaria || ""}
                    onCommit={(valor) => atualizarCampo("dataMassaUnitaria", valor)}
                    sx={inputTabelaSx}
                  />
                </TableCell>
                <TableCell />
                <TableCell sx={{ fontWeight: 700 }}>OPERADOR:</TableCell>
                <TableCell>
                  <CampoLocal
                    value={caracterizacao.operadorMassaUnitaria || ""}
                    onCommit={(valor) => atualizarCampo("operadorMassaUnitaria", valor)}
                    sx={inputTabelaSx}
                  />
                </TableCell>
              </TableRow>

              {massaUnitariaLinhas.map(([letra, descricao, formula, campo1, campo2, editavel], index) => (
                <TableRow key={`${letra}-${descricao}`}>
                  <TableCell align="center" sx={{ width: 42 }}>{letra}</TableCell>
                  <TableCell>{descricao}</TableCell>
                  <TableCell align="center">{formula}</TableCell>
                  {campo1 === "mediaMassaUnitaria" ? (
                    <TableCell colSpan={2} sx={celulaInputSx}>
                      {renderValorGrupo("massaUnitaria", campo1, editavel, index)}
                    </TableCell>
                  ) : (
                    <>
                      <TableCell sx={celulaInputSx}>
                        {renderValorGrupo("massaUnitaria", campo1, editavel, index)}
                      </TableCell>
                      <TableCell sx={celulaInputSx}>
                        {renderValorGrupo("massaUnitaria", campo2, editavel, index)}
                      </TableCell>
                    </>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>

        </fieldset>
        <Paper sx={{ p: 2, mb: 3 }}>
          <CampoLocal
            label="Observações"
            value={caracterizacao.observacoes || ""}
            onCommit={(valor) => atualizarCampo("observacoes", valor)}
            fullWidth
            multiline
            minRows={3}
          />
        </Paper>

        {(ensaioHabilitado("caracterizacao-torroes-argila") || ensaioHabilitado("caracterizacao-materiais-pulverulentos")) && renderTorroesPulverulentos()}
        {ensaioHabilitado("caracterizacao-abrasao-los-angeles") && renderAbrasaoLosAngeles()}
        {ensaioHabilitado("caracterizacao-particulas-leves") && renderParticulasLeves()}
        {ensaioHabilitado("caracterizacao-sais-cloretos-sulfatos") && renderSaisCloretosSulfatos()}
        {ensaioHabilitado("caracterizacao-indice-forma") && renderIndiceForma()}

      </Box>

      <Dialog open={normaDialog.open} onClose={fecharNormaReferencia} fullWidth maxWidth="sm">
        <DialogTitle>Editar norma de referência</DialogTitle>
        <DialogContent dividers>
          <TextField
            label="Norma de referência"
            value={normaDialog.valor}
            onChange={(event) =>
              setNormaDialog((prev) => ({
                ...prev,
                valor: event.target.value,
              }))
            }
            fullWidth
            multiline
            minRows={3}
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={fecharNormaReferencia} disabled={salvando}>Cancelar</Button>
          <Button variant="contained" onClick={salvarNormaReferencia} disabled={salvando}>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
